import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { Flex, FormControl, FormLabel } from '@chakra-ui/react';
var renderItem = function renderItem(e, code, current, index, _onClick) {
  var options = {
    id: "".concat(code, "-").concat(index),
    key: "".concat(code, "-").concat(index),
    name: "".concat(code),
    type: 'radio',
    value: "".concat(e.code),
    readOnly: true
  };
  var isOptionCurrent = e.product.code === current;
  if (isOptionCurrent) options.checked = 'checked';
  return /*#__PURE__*/React.createElement(Flex, {
    key: index,
    grow: "0",
    shrink: "1",
    mr: "-1px",
    "data-type": "clickable-item",
    sx: {
      input: {
        display: 'none'
      },
      '&:first-of-type label': {
        borderBottomLeftRadius: '4px',
        borderTopLeftRadius: '4px'
      },
      '&:last-child label': {
        borderBottomRightRadius: '4px',
        borderTopRightRadius: '4px'
      }
    },
    "data-testid": "molecules-Clickable-Flex"
  }, /*#__PURE__*/React.createElement("input", _extends({}, options, {
    "data-testid": "molecules-Clickable-input"
  })), /*#__PURE__*/React.createElement(FormLabel, {
    as: "label",
    cursor: "pointer",
    htmlFor: "".concat(e.code, "-").concat(index),
    onClick: function onClick() {
      return _onClick(e.product.url);
    },
    p: "8px 24px !important",
    position: "relative",
    marginInlineEnd: "0",
    mb: "0",
    fontFamily: "body",
    fontWeight: "400",
    "data-type": "clickable-item-label",
    sx: _objectSpread(_objectSpread({
      zIndex: '2',
      boxShadow: 'inset 0 0 0 1px #f9d839'
    }, isOptionCurrent ? {
      bgColor: '#f9d839'
    } : {}), {}, {
      _before: {
        display: 'none!important'
      },
      _after: {
        display: 'none!important'
      }
    })
  }, e.name));
};
export var Clickable = function Clickable(_ref) {
  var code = _ref.code,
    entries = _ref.entries,
    name = _ref.name,
    current = _ref.current,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(FormControl, {
    as: "fieldset",
    "data-type": "clickable-root"
  }, /*#__PURE__*/React.createElement(FormLabel, {
    as: "legend",
    fontFamily: "body",
    letterSpacing: "0",
    fontWeight: "400",
    fontSize: "sm",
    mb: "3xs",
    lineHeight: "1.5714285714",
    "data-testid": "molecules-Clickable-FormLabel"
  }, name), /*#__PURE__*/React.createElement(Flex, {
    wrap: "nowrap",
    align: "stretch"
  }, entries.map(function (entry, i) {
    return renderItem(entry, code, current, i, onClick);
  })));
};
export default Clickable;